import React from "react";

const SignedOutStatusIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="#BA1B1B" {...props}>
    <path d="M14.6667 12.7666L13.3333 11.4332V5.9999H7.90001L6.66668 4.76657V3.33324H5.23334L3.90001 1.9999H8.00001V4.66657H14.6667V12.7666ZM13.6667 15.5332L12.1 13.9999H1.33334V3.1999L0.466675 2.33324L1.40001 1.3999L14.6 14.5999L13.6667 15.5332ZM2.66668 12.6666H4.00001V11.3332H2.66668V12.6666ZM2.66668 9.9999H4.00001V8.66657H2.66668V9.9999ZM2.66668 7.33324H4.00001V5.9999H2.66668V7.33324ZM5.33334 12.6666H6.66668V11.3332H5.33334V12.6666ZM5.33334 9.9999H6.66668V8.66657H5.33334V9.9999ZM8.00001 12.6666H10.7667L9.43334 11.3332H8.00001V12.6666ZM12 8.66657H10.6667V7.33324H12V8.66657Z" />
  </svg>
);

export default SignedOutStatusIcon;
